import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { categories, posts } from "@/mocks/posts";
import { formatCount } from "@/utils/format";

export default function RankPage() {
  const ranked = [...posts].sort((a, b) => b.heat - a.heat);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />

      <section className="w-full bg-foreground-950">
        <div className="w-full px-4 md:px-8 py-10 md:py-14">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-5">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/20 px-3 py-1 text-xs font-semibold text-primary-300">
                <i className="ri-flashlight-fill" aria-hidden="true"></i>
                每 10 分钟更新
              </span>
              <h1 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-background-50">
                全网吃瓜热榜
              </h1>
              <p className="mt-3 max-w-2xl text-sm text-background-300/80">
                综合阅读量、讨论量与分享量计算的实时热度榜，看看此刻全网都在吃哪口瓜。
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              {categories.map((item) => (
                <Link
                  key={item.slug}
                  to={`/category/${item.slug}`}
                  className="rounded-full border border-background-50/20 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-100 whitespace-nowrap transition-colors hover:bg-background-50/20"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <main className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
          <ul className="divide-y divide-background-200/70">
            {ranked.map((post, index) => (
              <li key={post.id}>
                <Link
                  to={`/article/${post.id}`}
                  className="group flex items-center gap-4 md:gap-6 p-4 md:p-5 transition-colors hover:bg-background-100"
                >
                  <span
                    className={`flex h-9 w-9 md:h-11 md:w-11 shrink-0 items-center justify-center rounded-lg font-heading text-lg md:text-xl font-bold ${
                      index < 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="h-16 w-24 md:h-20 md:w-32 shrink-0 overflow-hidden rounded-md">
                    <img
                      src={post.cover}
                      alt={`${post.title}相关配图`}
                      title={`${post.title} - 吃瓜看料`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2 mb-1.5">
                      <span className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800 whitespace-nowrap">
                        {post.categoryName}
                      </span>
                      {index < 3 && (
                        <span className="rounded bg-primary-100 px-2 py-0.5 text-xs text-primary-700 whitespace-nowrap">
                          爆
                        </span>
                      )}
                    </div>
                    <h2 className="font-heading text-sm md:text-lg font-semibold leading-snug text-foreground-950 line-clamp-2 transition-colors group-hover:text-primary-600">
                      {post.title}
                    </h2>
                    <p className="mt-1.5 hidden sm:block text-xs md:text-sm text-foreground-500 line-clamp-1">
                      {post.excerpt}
                    </p>
                  </div>
                  <div className="hidden md:flex flex-col items-end shrink-0">
                    <span className="flex items-center gap-1 font-heading text-lg font-bold text-primary-600">
                      <i className="ri-fire-fill" aria-hidden="true"></i>
                      {formatCount(post.heat)}
                    </span>
                    <span className="mt-1 text-xs text-foreground-500">
                      {formatCount(post.views)} 阅读
                    </span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}